import { render, staticRenderFns } from "./CreateTemplateModal.vue?vue&type=template&id=7a56e084&"
import script from "./CreateTemplateModal.vue?vue&type=script&lang=js&"
export * from "./CreateTemplateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a56e084')) {
      api.createRecord('7a56e084', component.options)
    } else {
      api.reload('7a56e084', component.options)
    }
    module.hot.accept("./CreateTemplateModal.vue?vue&type=template&id=7a56e084&", function () {
      api.rerender('7a56e084', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/whatsapp/template/component/CreateTemplateModal.vue"
export default component.exports